import { RadioGroup as PrimitiveRadioGroup } from "@ark-ui/react";
import type { ComponentProps } from "react";
import Item from "./Item/Item";

type RootProps = ComponentProps<typeof PrimitiveRadioGroup.Root>;
type CustomProps = {
  size?: "sm" | "md" | "lg";
  color?: "primary" | "secondary";
};

type Props = RootProps & CustomProps;

const RadioRoot = ({ children, size = "md", color = "primary", ...rest }: Props) => {
  return (
    <PrimitiveRadioGroup.Root data-size={size} data-color={color} {...rest}>
      {children}
    </PrimitiveRadioGroup.Root>
  );
};

export const Radio = Object.assign(RadioRoot, {
  Item,
});
